import { createContext } from "react";
import type { OnboardingStep } from "./constants";

export interface OnboardingContextValue {
    startIntroTour: () => void;
    startNavigationTour: () => void;
    startDashboardOverviewTour: () => void;
    startDashboardAnalyticsTour: () => void;
    registerBeforeAnalyticsTour: (fn: () => void) => () => void;
    startDashboardHeatmapTour: () => void;
    startDashboardCompareTour: () => void;
    startDashboardTeamComparisonTour: () => void;
    startPlayersTour: () => void;
    startPlayerProfileTour: () => void;
    startLeaderboardsTour: () => void;
    startTournamentOverviewTour: () => void;
    startTournamentCompareTour: () => void;
    startTournamentRankingTour: () => void;
    startTeamsTour: () => void;
    startTeamProfileTour: () => void;
    startTeamPlayersTour: () => void;
    startTeamAnalysisTour: () => void;
    startTeamCompareTour: () => void;
    startTeamH2HTour: () => void;
    startScoutingPlayersTour: () => void;
    startKpisCurrentTour: () => void;
    startChatTour: () => void;
    registerBeforeChatTour: (fn: () => void) => () => void;
    startSettingsMultiplierTour: () => void;
    startSettingsReportTour: () => void;
    startDashboardPeriodDataTour: () => void;
    startTournamentLinesTour: () => void;
    registerBeforeTournamentLinesTour: (fn: () => void) => () => void;
    markComplete: (step: OnboardingStep) => void;
    isComplete: (step: OnboardingStep) => boolean;
}

export const OnboardingContext = createContext<OnboardingContextValue | null>(null);
